// extracted by mini-css-extract-plugin
export default {"select":"select_select__r7MX5","label":"select_label__AsRyF"};